import { InjectionToken } from '@angular/core';
import { IncidencePlatformApiService } from './incidence-platform-api.service';

export const HTTP_INCIDENCE_PLATFORM_SERVICE =
  new InjectionToken<IncidencePlatformApiService>(
    'IncidencePlatformApiService'
  );

export const INCIDENCE_PLATFORM_PROVIDER = {
  provide: HTTP_INCIDENCE_PLATFORM_SERVICE,
  useClass: IncidencePlatformApiService,
};
